var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurchaseInv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93181 8.49064V5.10064C5.93181 4.63451 5.55048 4.25313 5.08441 4.25313H1.6948V2.55813H5.93181V0.863127H3.81331V0.015625H2.1185V0.863127H0.847401C0.381331 0.863127 0 1.2445 0 1.71063V5.10064C0 5.56676 0.381331 5.94814 0.847401 5.94814H4.23701V7.64314H0V9.33815H2.1185V10.1856H3.81331V9.33815H5.08441C5.55048 9.33815 5.93181 8.95677 5.93181 8.49064Z",
    fill: "#361A52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0009 12.0627H10.0801V11.9835V11.2812V11.202H10.0009H5.08594H5.00668V11.2812V11.9835V12.0627H5.08594H10.0009Z",
    fill: "#361A52",
    stroke: "#361A52",
    strokeWidth: 0.158523
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseInv);
export default __webpack_public_path__ + "static/media/PurchaseInv.40b0c073fd7facb1a23e97ab040a9845.svg";
export { ForwardRef as ReactComponent };